var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBottomLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 109,
    viewBox: "0 0 146 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5418_13947)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5418_13947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.201 3.07812H6.07282C3.543 3.07812 1.49219 5.12894 1.49219 7.65875V101.562C1.49219 104.091 3.543 106.142 6.07282 106.142H141.201C143.731 106.142 145.782 104.091 145.782 101.562V7.65875C145.782 5.12894 143.731 3.07812 141.201 3.07812Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8037 16.8183C16.7523 16.8183 17.5214 16.0492 17.5214 15.1005C17.5214 14.1519 16.7523 13.3828 15.8037 13.3828C14.855 13.3828 14.0859 14.1519 14.0859 15.1005C14.0859 16.0492 14.855 16.8183 15.8037 16.8183Z",
    fill: "#EF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5302 16.8183C22.4789 16.8183 23.248 16.0492 23.248 15.1005C23.248 14.1519 22.4789 13.3828 21.5302 13.3828C20.5816 13.3828 19.8125 14.1519 19.8125 15.1005C19.8125 16.0492 20.5816 16.8183 21.5302 16.8183Z",
    fill: "#FCD34D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2568 16.8183C28.2055 16.8183 28.9745 16.0492 28.9745 15.1005C28.9745 14.1519 28.2055 13.3828 27.2568 13.3828C26.3081 13.3828 25.5391 14.1519 25.5391 15.1005C25.5391 16.0492 26.3081 16.8183 27.2568 16.8183Z",
    fill: "#83E83F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.021 24.8359H18.6666C16.1368 24.8359 14.0859 26.8868 14.0859 29.4166V46.5939C14.0859 49.1237 16.1368 51.1745 18.6666 51.1745H124.021C126.551 51.1745 128.602 49.1237 128.602 46.5939V29.4166C128.602 26.8868 126.551 24.8359 124.021 24.8359Z",
    fill: "#4B22A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7982 55H16.8629C15.2818 55 14 56.2818 14 57.8629V57.8629C14 59.444 15.2818 60.7258 16.8629 60.7258H55.7982C57.3793 60.7258 58.6611 59.444 58.6611 57.8629C58.6611 56.2818 57.3793 55 55.7982 55Z",
    fill: "#4B22A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1719 84.1406C34.1719 78.0655 29.247 73.1406 23.1719 73.1406C17.0967 73.1406 12.1719 78.0655 12.1719 84.1406C12.1719 90.2158 17.0967 95.1406 23.1719 95.1406C29.247 95.1406 34.1719 90.2158 34.1719 84.1406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9974 85.0052C22.5316 85.0052 22.1374 84.8439 21.8147 84.5212C21.4921 84.1986 21.3307 83.8043 21.3307 83.3386V79.3385C21.3307 78.8728 21.4921 78.4785 21.8147 78.1559C22.1374 77.8332 22.5316 77.6719 22.9974 77.6719C23.4632 77.6719 23.8574 77.8332 24.1801 78.1559C24.5027 78.4785 24.6641 78.8728 24.6641 79.3385V83.3386C24.6641 83.8043 24.5027 84.1986 24.1801 84.5212C23.8574 84.8439 23.4632 85.0052 22.9974 85.0052ZM22.4974 89.8386V87.641C21.3974 87.5154 20.4835 87.0436 19.7557 86.2257C19.028 85.4077 18.6641 84.4453 18.6641 83.3386H19.6641C19.6641 84.2608 19.9891 85.0469 20.6391 85.6969C21.2891 86.3469 22.0752 86.6719 22.9974 86.6719C23.9196 86.6719 24.7057 86.3469 25.3557 85.6969C26.0057 85.0469 26.3307 84.2608 26.3307 83.3386H27.3307C27.3307 84.4453 26.9668 85.4077 26.2391 86.2257C25.5113 87.0436 24.5974 87.5154 23.4974 87.641V89.8386H22.4974Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5418_13947"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 145.651,
    height: 107.804,
    fill: "white",
    transform: "translate(0.582031 0.90625)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5418_13947"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 145.651,
    height: 103.453,
    fill: "white",
    transform: "translate(0.582031 3.07812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomLeft);
export default __webpack_public_path__ + "static/media/BottomLeft.03ff07be31af2d6b25c8f5e16e908518.svg";
export { ForwardRef as ReactComponent };